import React, { useEffect, useRef } from 'react';
import '../components-css/modalList.css'; // Extract styles here

const ListModal = ({ show, onClose, children }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const body = document.body;
        if (show) {
            body.classList.add('no-scroll');
        } else {
            body.classList.remove('no-scroll');
        }
        return () => body.classList.remove('no-scroll');
    }, [show]);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    if (!show) return null;

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            
            <div className="modal-content" ref={modalRef}>
                <button className="modal-close-button" onClick={onClose}>x</button>
                <div className='modal-form'>
                    <div className="modal-scroll-area">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListModal;
